import { render } from "./ProfilePasswordPage.vue?vue&type=template&id=d6f8507a&ts=true"
import script from "./ProfilePasswordPage.vue?vue&type=script&lang=ts"
export * from "./ProfilePasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__